__webpack_require__.p = "/coup-sheet/";